import React from 'react';
import { useCurrency } from '../../context/CurrencyContext';

const PriceDisplay = ({ 
  price, 
  className = '', 
  showCurrency = true, 
  currencyCode,
  size = 'base'
}) => {
  const { formatPrice, currency } = useCurrency();

  const sizeClasses = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl'
  };

  const displayPrice = formatPrice(price, currencyCode || currency);
  
  return (
    <span 
      className={`font-semibold ${sizeClasses[size]} ${className}`}
      style={{ color: '#10b981' }}
    >
      {displayPrice}
    </span>
  );
};

export default PriceDisplay;
